import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_candles_warmers: FaireCategoryEntity = {
  token: "cat_candles-warmers",
  type: "category",
  name: "Wax warmers & melts",
  level: 3,
  parentToken: "cat_home-decor-candles",
  href: "/category/home-decor/candles-holders/wax-warmers-melts",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
